export const config = {
  title: "H&D Cleaning Services LLC | Professional Cleaning Services in Richmond, VA",
  meta: {
    description:
      "H&D Cleaning Services LLC offers reliable residential and commercial cleaning services in Richmond, VA, including deep cleaning, house cleaning, and office cleaning.",
    keywords: [
      'Cleaning Services Richmond VA',
      'H&D Cleaning Services LLC',
      'Residential Cleaning',
      'Commercial Cleaning',
      'Deep Cleaning',
      'House Cleaning',
      'Office Cleaning',
      'Professional Cleaning',
      'Reliable Cleaning Services',
      'Richmond VA Cleaners'
    ],
    author: "H&D Cleaning Services LLC",
    canonicalUrl: 'https://hdcleaningservicesllc.com/',
  },
  sections: {
    header: {
      businessName: "H&D Cleaning Services LLC",
    },
    sectionB: {
      heroTitle: "H&D Cleaning Services LLC",
      heroSubtitle: 'Reliable & Professional Cleaning Services for Residential and Commercial Customers',
      learnAboutText: 'Discover Our Cleaning Services',
      phoneNumber: '8044012841',
      phoneLabel: '(804) 401-2841',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2159632844/photo/commercial-office-cleaners.jpg?s=612x612&w=0&k=20&c=1cgFp-uxCXLAXY9yAB_hQNZqq6hcTZ0bVG77D7njKVY=",
      cardData: [
        {
          title: 'Over 10 Years of Experience',
          description: 'Providing quality, reliable cleaning services that exceed expectations without emptying your wallet.',
        },
        {
          title: 'Comprehensive Cleaning Solutions',
          description: 'Offering deep cleaning, house cleaning, and office cleaning services tailored to your needs.',
        },
        {
          title: 'Customer Satisfaction',
          description: 'Committed to delivering spotless, sanitized, and welcoming environments for our clients.',
        },
      ],
      description:
        "H&D Cleaning Services LLC specializes in providing high-quality residential and commercial cleaning services, including deep cleaning, house cleaning, and office cleaning. Our team is dedicated to delivering exceptional results that ensure your space remains fresh, tidy, and inviting.",
    },
    sectionC: {
      servicesTitle: 'Our Cleaning Services',
      servicesDescription:
        "Explore the wide range of professional cleaning services we offer to maintain a pristine environment.",
      cards: [
        {
          title: 'Deep Cleaning',
          description:
            'Our deep cleaning service targets every corner of your space, removing built-up dirt, dust, and grime for a fresh, sanitized, and spotless environment. Ideal for seasonal or one-time cleanings.',
          imageSrc: 'https://hdcleaningservicesllc.com//wp-content/uploads/2025/01/H-D-cleanig-services-img-1.jpg',
          imageAlt: 'Deep Cleaning',
        },
        {
          title: 'House Cleaning',
          description:
            'We provide thorough and reliable house cleaning, ensuring your home stays fresh, tidy, and welcoming. From kitchens to bedrooms, we handle every detail for a pristine living space.',
          imageSrc: 'https://hdcleaningservicesllc.com//wp-content/uploads/2025/01/H-D-cleanig-services-img-8.jpg',
          imageAlt: 'House Cleaning',
        },
        {
          title: 'Office Cleaning',
          description:
            'A clean office enhances productivity and professionalism. Our office cleaning service ensures workspaces are spotless, sanitized, and inviting, creating a healthier and more organized environment for employees and clients.',
          imageSrc: 'https://hdcleaningservicesllc.com//wp-content/uploads/2025/01/H-D-cleanig-services-img-2.jpg',
          imageAlt: 'Office Cleaning',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Move-In/Move-Out Cleaning',
        'Post-Construction Cleaning',
        'Carpet Cleaning',
        'Window Cleaning',
        'Floor Care Services',
        'Customized Cleaning Plans',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://hdcleaningservicesllc.com//wp-content/uploads/2025/01/H-D-CLEANING-SERVICES-LLC-1.jpg',
        alt: "H&D Cleaning Services LLC Team",
      },
      aboutText: [
        "H&D Cleaning Services LLC is an independently owned residential cleaning company that has been serving homeowners and other clients in Richmond and surrounding areas for over 10 years.",
        "We understand that it can be a challenge to find the time and energy to clean your own home. That's why we're committed to providing quality, reliable cleaning services that will exceed your expectations – without emptying your wallet.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "H&D Cleaning Services LLC Logo",
      businessName: "H&D Cleaning Services LLC",
      contact: {
        phone: '8044012841',
        phoneLabel: '(804) 401-2841',
        email: 'garciadarleni890@gmail.com',
        website: 'https://hdcleaningservicesllc.com/',
        address: 'Richmond, VA',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/people/Cindys-house-keeping/100091952268235/',
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: 'Richmond, VA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d-77.436048!3d37.540725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b111234567890b%3A0x1234567890abcdef!2sRichmond%2C%20VA%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
